module.exports = __webpack_public_path__ + "static/media/mobirise-icons.527def02.woff";